<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Orders & Deliveries Reports",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {PageHeader, Layout},
name: "default",
  data() {
    return {
      title: "Orders & Deliveries Reports",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Orders & Deliveries Reports",
          active: true
        }
      ],
    }
  }
}
</script>

<style scoped>

</style>
